import './index.css';

import { useUserInfo } from './hooks/useUserInfo';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { _404 } from './elements/404';
import { Contract } from './elements/Contract';
import { Job } from './elements/Job';
import { Search } from './elements/Search';
import { Site } from './elements/Site';
import { PortalHeader } from '@portal_components/components/PortalHeader';
import { PortalFooter } from '@portal_components/components/PortalFooter';
import { NavigationWrapper } from './elements/NavigationWrapper';
import { SiteNavigationWrapper } from './elements/SiteNavigationWrapper';
import { UserInfoLoading } from './elements/UserInfoLoading';
import { useStandingData } from './hooks/useStandingData';
import { FormBookJobCommunications } from './elements/booking/siteInfo/FormBookJobCommunications';
import { FormBookJobWarrantInfo } from './elements/booking/siteInfo/FormBookJobWarrantInfo';
import { FormBookJobSiteInfoWrapper } from './elements/booking/siteInfo/FormBookJobSiteInfoWrapper';
import { FormBookJobJobType } from './elements/booking/siteInfo/FormBookJobJobType';
import { BookingResult } from './elements/booking/bookingResult/BookingResult';
import { BookJobOffers } from './elements/booking/offers/BookJobOffers';
import { BookJobOffersInternal } from './elements/booking/offers/BookJobOffersInternal';
import { BookingResultLoading } from './elements/loadingElements/BookingResultLoading';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Search />,
    errorElement: <_404 />
  },
  {
    path: 'contract/:mpan/:serviceLine',
    element: <Contract />
  },
  {
    path: 'job/:bookingId/:mpan/:serviceLine/:contractId',
    element: <Job />
  },
  {
    path: 'site/:mpan/:serviceLine',
    element: <SiteNavigationWrapper />,
    children: [
      {
        path: '',
        element: <Site />
      }
    ]
  },
  {
    path: 'bookingResultloading/:mpan/:serviceLine',
    element: <BookingResultLoading />
  },
  {
    path: '',
    element: <NavigationWrapper />,
    children: [
      {
        path: 'bookJob/siteJobType/:mpan/:serviceLine',
        element: <FormBookJobJobType />
      },
      {
        path: 'bookJob/siteInfo/:mpan/:serviceLine/:jobTypeCode',
        element: <FormBookJobSiteInfoWrapper />
      },
      {
        path: 'bookJob/warrantSiteInfo/:mpan/:serviceLine/:jobTypeCode',
        element: <FormBookJobWarrantInfo />
      },
      {
        path: 'bookJob/communications/:mpan/:serviceLine',
        element: <FormBookJobCommunications />
      },
      {
        path: 'bookJob/offers/:mpan/:serviceLine',
        element: <BookJobOffers />
      },
      {
        path: 'bookJob/internalOffers/:mpan/:serviceLine',
        element: <BookJobOffersInternal />
      },
      {
        path: 'bookingResult/:mpan/:serviceLine',
        element: <BookingResult />
      }
    ]
  },
  {
    path: '404',
    element: <_404 />
  }
]);

function App() {
  const { isUserInfoLoading, userInfo, userDataError } = useUserInfo();
  const { isStandingDataLoading, standingDataError } = useStandingData();

  const isBootstrapping = isUserInfoLoading || isStandingDataLoading || userDataError || standingDataError;

  return (
    <div>
      <PortalHeader title="Job Booking Portal" applications={userInfo?.applications} userEmail={userInfo?.user} navigate={router.navigate} />
      {(isBootstrapping || userDataError) && <UserInfoLoading />}
      {!isBootstrapping && userInfo && <RouterProvider router={router} />}
      <PortalFooter />
    </div>
  );
}

export default App;
